import {
  useInjectReducer as useReducer,
  useInjectSaga as useSaga,
  createManager as createReduxManager,
} from 'redux-injectors';
import {
  CreateManagerParams,
  InjectReducerParams,
  InjectSagaParams,
  RootStateKeyType,
} from './types/injector-typings';

/* Wrap redux-injectors with stricter types */

export function useInjectReducer<Key extends RootStateKeyType>(
  params: InjectReducerParams<Key>,
) {
  return useReducer(params);
}

export function useInjectSaga(params: InjectSagaParams) {
  return useSaga(params);
}

export const createManager = <Key extends RootStateKeyType>(
  params: CreateManagerParams<Key>,
  // @ts-ignore // incorrect type declaration export from library : https://github.com/react-boilerplate/redux-injectors/issues/35
) => createReduxManager(params);
